"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var HAMBURGER_MENU_DEFAULTS = {
  DATA: {
    BGCOLOR: 'default',
    ACTIVE_BGCOLOR: 'primary',
    TITLE_COLOR: 'greyDark',
    TITLE_SIZE: 'normal'
  },
  MENU: {
    ICON: 'Menu',
    COLOR: 'neutral',
    SIZE: 'titleNormal'
  },
  ICON_LEFT: {
    COLOR: 'neutral',
    SIZE: 'medium'
  },
  TEXT: {
    COLOR: 'neutral',
    SIZE: 'normal'
  },
  ICON_RIGHT: {
    COLOR: 'neutral',
    SIZE: 'medium'
  },
  ZINDEX: 11,
  CLOSE_BTN: {
    ICON: 'CloseIcon',
    COLOR: 'default',
    SIZE: 'titleNormal'
  }
};
var _default = HAMBURGER_MENU_DEFAULTS;
exports.default = _default;